import moment from "moment"

export const formartDataToFix = (data, dw, newItens = false) => {
  
  if(newItens){
    return data
  }
  else {
    if (!data || !data[0] || !data.length) {
      return []
    }
  
    let additionalData = data.map((item) => ({
      Etapa: item.Etapa,
      Etapa_Pergunta: item.Etapa_Pergunta,
      Pergunta_codigo: item.Pergunta_codigo,
      Pergunta_codigo_1: item.Pergunta_codigo,
      Etapa_Pergunta_codigo: item.Etapa_Pergunta_codigo,
      Etapa_codigo: item.Etapa_codigo,
      Pergunta: item.Pergunta,
      Resposta: item.Resposta === "Ø" ? "Sem Resposta" : item.Resposta,
      Produtor: item.Produtor,
      ProdutorId: item.ProdutorId,
      Formulario: dw?.forms && dw.forms.find((row) => row.value === item.Formulario),
      Projeto: item.Projeto,
      Tecnico: item.Tecnico,
      Data: item.Inicio,
      ID: item.ID,
      Tipo_Pergunta: item.Tipo_Pergunta,
      question: item.Pergunta?.replace(":", " - "),
    }))
  
    const array = [
      {
        id: additionalData[0].ID,
        step: additionalData[0].Etapa,
        title: additionalData[0].Etapa,
        components: [
          {
            codes: [
              {
                title: "Resposta",
                code: additionalData[0].Pergunta_codigo_1,
              },
              {
                title: "Técnico",
                code: "Tecnico",
              },
            ],
            [additionalData[0].Pergunta_codigo]: additionalData[0].Resposta,
            stackedBy: "Produtor",
            fields: [
              additionalData.map((item, index) => {
                return {
                  ID: item.ID,
                  ProdutorId: item.ProdutorId,
                  Produtor: item.Produtor,
                  Tecnico: item.Tecnico,
                  Inicio: moment(item.Data).format("DD/MM/YYYY"),
                  Etapa: item.Etapa,
                  Pergunta: item.Pergunta,
                  Pergunta_codigo_1: item.Pergunta_codigo,
                  Projeto: item.Projeto,
                  Tipo_Pergunta: item.Tipo_Pergunta,
                  realInicio: item.Data,
                  [item.Pergunta_codigo]: item.Resposta || 0,
                  value: item.Pergunta_codigo,
                  inFilter: true,
                }
              }),
            ],
            columns: ["Tecnico", additionalData[0].Pergunta_codigo_1],
            standardDeviation: {
              title: "",
              code: "",
              info: [],
            },
            type: "",
            question: additionalData[0].question || "",
            value: additionalData[0].Pergunta_codigo,
          },
        ],
      },
    ]

    return array
  }

  
}

export const getQuestionType = (data) => {
  const questionTypequestionValue = [...new Set(data.map((item) => item.Tipo_Pergunta))][0]
  return questionTypequestionValue
}

export const formatCharts = (data, questionValue, projectId, newItens = false) => {


  let format = []
  
  if(newItens){
  const types = ["pie", "bar-percent", "bar", "bar-variation", "table"]

  format = types.flatMap((type) => {
    const itens = data.flatMap((item) =>
      item.components.map((item2) => {
        return {
          ...item2,
          type,
          fields: item2.fields[0],
          title: questionValue.split(":")[0],
          projectId,
        }
      }),
    )
    return itens
  })

  }
  else {
    // console.log(data)
  }
  return format
}

export const dataToFix = (
  initialComponents,
  fixedComponentsData,
  fixedComponents,
  componentType,
  questionValue,
  projectId,
  dispatch,
  setData,
  chartsTofix,
) => {
  const existsQuestion =
    fixedComponentsData &&
    fixedComponentsData.some(
      (fixedGraph) =>
        fixedGraph?.question == questionValue.replace(":", " - ") &&
        fixedGraph?.projectId == projectId &&
        fixedGraph?.type == componentType,
    )

  const dataToFix = initialComponents
    .filter(
      (item) =>
        Array.isArray(fixedComponents) &&
        fixedComponents?.some((item2) => item2 == item?.type) &&
        componentType == item?.type,
    )
    .map((item) => {
      return {
        ...item,
        ID: Math.floor(Math.random() * 100) + projectId,
      }
    })

  if (!existsQuestion && dataToFix.length > 0) {
    //setComponentFixed({type: componentType, question: questionValue, formId: })
    dispatch(
      setData({
        fixedComponentsData: fixedComponentsData?.concat(...dataToFix),
      }),
    )
  }
}
